import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { healthCheckAsync } from "../../redux/reducers/healthCheckSlice";
import Loader from "../loader/loader";

const HealthCheckGuard = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isError, isLoading, data } = useSelector(
    (state) => state?.health ?? {}
  );

  useEffect(() => {
    dispatch(healthCheckAsync())
      .unwrap()
      .catch(() => {
        navigate("/page-under-construction"); // redirect if health check fails
      });
  }, [dispatch, navigate]);

  if (isLoading || !data) {
    return <Loader loading={isLoading} />;
  }

  return children;
};

export default HealthCheckGuard;
